import MemberBar from 'pages/Feedback/components/Top/MemberBar/MemberBar';
import React from 'react';
import './ReviewItem.module.scss';

type Props = {
  item?: string;
  user?: UserEntity;
  name?: string;
  type?: string;
  improvement?: string;
  good?: string;
  agrees?: boolean;
};

export default function ReviewItem({
  item,
  user,
  name,
  type,
  improvement,
  good,
  agrees,
}: Props) {
  return (
    <div styleName="wrapper">
      <div styleName="top ">
        <div>
          <MemberBar
            user={user}
            name={
              <h3 styleName="name">
                {user?.first_name} {user?.last_name}
              </h3>
            }
          />
        </div>
        {name && (
          <div styleName="activity">
            <p styleName="header">Ontvangen op: </p>
            <p styleName="sub">
              "{`${type === 'training' ? 'Training:' : ''}`}
              {name}"
            </p>
          </div>
        )}
      </div>
      {item && (
        <div styleName="text">
          <p>{item}</p>
        </div>
      )}
      {improvement || good ? (
        <div styleName="feedback">
          <div styleName="feedback-text">
            <p styleName="header">Wat kan er beter?</p>
            <p styleName="txt">{improvement}</p>
          </div>
          <div styleName="feedback-text">
            <p styleName="header">Wat ging er goed?</p>
            <p styleName="txt">{good}</p>
          </div>
        </div>
      ) : null}
      {agrees && (
        <p styleName="agrees">
          De tweede beoordelaar is het eens met de eerste beoordelaar en kon
          daarom geen feedback achterlaten.
        </p>
      )}
    </div>
  );
}
